var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9883 8.25H6.98828C5.99372 8.25 5.03989 8.64509 4.33663 9.34835C3.63337 10.0516 3.23828 11.0054 3.23828 12V36C3.23828 36.9946 3.63337 37.9484 4.33663 38.6516C5.03989 39.3549 5.99372 39.75 6.98828 39.75H42.9883C43.9828 39.75 44.9367 39.3549 45.6399 38.6516C46.3432 37.9484 46.7383 36.9946 46.7383 36V12C46.7383 11.0054 46.3432 10.0516 45.6399 9.34835C44.9367 8.64509 43.9828 8.25 42.9883 8.25ZM42.2383 12.75V16.5H7.73828V12.75H42.2383ZM7.73828 35.25V21H42.2383V35.25H7.73828ZM39.9883 30.75C39.9883 31.3467 39.7512 31.919 39.3293 32.341C38.9073 32.7629 38.335 33 37.7383 33H31.7383C31.1415 33 30.5692 32.7629 30.1473 32.341C29.7253 31.919 29.4883 31.3467 29.4883 30.75C29.4883 30.1533 29.7253 29.581 30.1473 29.159C30.5692 28.7371 31.1415 28.5 31.7383 28.5H37.7383C38.335 28.5 38.9073 28.7371 39.3293 29.159C39.7512 29.581 39.9883 30.1533 39.9883 30.75ZM27.2383 30.75C27.2383 31.3467 27.0012 31.919 26.5793 32.341C26.1573 32.7629 25.585 33 24.9883 33H22.7383C22.1415 33 21.5692 32.7629 21.1473 32.341C20.7253 31.919 20.4883 31.3467 20.4883 30.75C20.4883 30.1533 20.7253 29.581 21.1473 29.159C21.5692 28.7371 22.1415 28.5 22.7383 28.5H24.9883C25.585 28.5 26.1573 28.7371 26.5793 29.159C27.0012 29.581 27.2383 30.1533 27.2383 30.75Z",
    fill: "url(#paint0_linear_1559_11679)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1559_11679",
    x1: 24.9883,
    y1: 8.25,
    x2: 24.9883,
    y2: 39.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/CreditCard.89094a47bd360d1e998a5a634ae97d04.svg";
export { ForwardRef as ReactComponent };